import { resendActiveEmail } from "@/services/passport/passport.service"
import { Alert, Button, Form, Input } from "antd"
import { useEffect } from "react"

export const VerifyEmail = ({email = ''}: {email?: string}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({email})
  }, [email])

  const resend = (values) => {
    resendActiveEmail(values.email)
  }

  return <Form form={form} onFinish={resend} className="mt-2">
        Please verify your email.<br/>
      <Form.Item
        name='email'
        label='Email'
        rules={[
          {
            required: true,
            message: 'Email is required',
          },
        ]}
      >
        <Input placeholder="Please input email" disabled={!!email} />
      </Form.Item>
      <div className="flex-center">
        <Button
          htmlType="submit"
          style={{width: '80%'}} type="primary" className="mt-2 full-width">Send Email</Button>
      </div>
      <div className="mt-1 flex-center" style={{fontStyle: 'italic'}}>(Can’t find the email? Check your spam folder.)</div>
    </Form>
}